import { isMobile } from './device_helpers';

// Must stay in CommonJS format
const PerfectScrollbar = require('perfect-scrollbar').default;

/**
 * Initialise scrollbars using perfect Scrollbar.
 * @param {Node} countryList - dropdown.
 */
const _initScrollbar = countryList => {
    let scrollbar = new PerfectScrollbar(countryList, {
        wheelPropagation: true,
        minScrollbarLength: 40
    });
    return scrollbar;
};

/**
 * Gets width of whole input to match search and dropdown.
 * @param {Node} container - phone input wrapper element.
 */
const _getInputWidth = container => {
    let intlTelInput = container.querySelector('.intl-tel-input');
    return intlTelInput.offsetWidth;
};

/**
 * Initialises width of dropdown and returns a function to carry out the same task on resize.
 * @param {Node} container - phone input wrapper element.
 */
const _sizedDropdown = container => {
    let countryList = container.querySelector('.country-list');
    let width = _getInputWidth(container);
    countryList.style.width = `${width}px`;
    return () => {
        countryList.style.width = `${_getInputWidth(container)}px`;
    };
};

/**
 * Initialises width of search and returns a function to carry out the same task on resize.
 * @param {Node} container - phone input wrapper element.
 */
const _sizedSearch = container => {
    let searchWrapper = container.querySelector('.telinput-search');
    let width = _getInputWidth(container);
    searchWrapper.style.width = `${width}px`;
    return () => {
        searchWrapper.style.width = `${_getInputWidth(container)}px`;
    };
};

/**
 * Initialises the resize events.
 * @param {Node} container - country-list wrapper.
 */
export const initWindowHandler = container => {
    if (!isMobile()) {
        const dropdownHandler = _sizedDropdown(container);
        const searchHandler = _sizedSearch(container);

        window.addEventListener('resize', e => {
            dropdownHandler();
            searchHandler();
        });
    }
};

/**
 * Adds to opening and closing handlers by toggling a class on the main phone input.
 * @param {Node} container - phone input wrapper element.
 */
export const initEvents = (inputContainer, listContainer) => {
    const intlTelInput = inputContainer.querySelector('.intl-tel-input');
    const flagContainer = inputContainer.querySelector('.flag-container');
    const countryList = listContainer.querySelector('.country-list');

    flagContainer.addEventListener('click', e => {
        setTimeout(() => {
            const hidden = countryList.classList.contains('hide');
            if (hidden) {
                intlTelInput.classList.remove('is-open');
            } else {
                intlTelInput.classList.add('is-open');
            }
        }, 50);
    });
    document.body.addEventListener('click', e => {
        if (!flagContainer.contains(e.target)) {
            intlTelInput.classList.remove('is-open');
        }
    });

    // Leave me down here
    if (!isMobile()) {
        _initScrollbar(countryList);
    }
};

/**
 * Corrects positioning of the label being used as a placeholder.
 * @param {Node} label - main tel input label (acting as placeholder).
 * @param {Node} container - phone input wrapper element.
 */
export const labelPositioning = (label, container) => {
    let flagDropdown = container.querySelector('.flag-container');
    label.style.left = `${8 + 15 + flagDropdown.offsetWidth}px`;
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/phoneinput.js